
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { LanguageProvider } from '@/context/LanguageProvider';
import { ThemeProvider } from '@/context/ThemeProvider';
import { SlimeProvider } from '@/context/SlimeContext';
import { ResourceProvider } from '@/context/ResourceContext';
import { UserProvider } from '@/context/UserContext';
import { AppConfigProvider } from '@/context/AppConfigContext';
import { AnalyticsProvider } from '@/components/providers/AnalyticsProvider';
import { TRPCProvider } from '@/providers/TRPCProvider';
import { Toaster } from '@/components/ui/toaster';
import ErrorBoundary from '@/components/common/ErrorBoundary';
import AppRouter from '@/router';

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <TRPCProvider>
        <ThemeProvider>
          <AppConfigProvider>
            <UserProvider>
              <ResourceProvider>
                <SlimeProvider>
                  <LanguageProvider>
                    <AnalyticsProvider>
                      <BrowserRouter>
                        <AppRouter />
                        <Toaster />
                      </BrowserRouter>
                    </AnalyticsProvider>
                  </LanguageProvider>
                </SlimeProvider>
              </ResourceProvider>
            </UserProvider>
          </AppConfigProvider>
        </ThemeProvider>
      </TRPCProvider>
    </ErrorBoundary>
  );
};

export default App;
